import {
  BookOpen,
  FileDown,
  Newspaper,
  TrendingUp,
  Trophy,
  type LucideIcon,
} from "lucide-react";

/** Decorative tile icon for each Resources menu item, keyed by its path. */
export const resourceIcons: Record<string, LucideIcon> = {
  "/best-law-firm-seo-companies": Trophy,
  "/case-studies": TrendingUp,
  "/blog": Newspaper,
  "/guides": FileDown,
  "/glossary": BookOpen,
};
